// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Oxanium-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Oxanium-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Oxanium-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Oxanium-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Oxanium-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Oxanium-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/Oxanium-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Oxanium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 200;
}
@font-face {
  font-family: "Oxanium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: 300;
}
@font-face {
  font-family: "Oxanium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-weight: 400;
}
@font-face {
  font-family: "Oxanium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-weight: 500;
}
@font-face {
  font-family: "Oxanium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-weight: 600;
}
@font-face {
  font-family: "Oxanium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-weight: 700;
}
@font-face {
  font-family: "Oxanium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-weight: 800;
}
.overlay-custom {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  z-index: 2;
}

.content-custom {
  padding: 24px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #100f0f;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 32px;
  overflow: auto;
  outline: none;
}

.overlay-side,
.overlay-side-burger {
  background: rgba(0, 0, 0, 0.3);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
}

.overlay-side {
  z-index: 2;
}

.overlay-side-burger {
  z-index: 1;
}

.modal-wrapper {
  width: 480px !important;
  height: calc(100% - 64px) !important;
  margin-top: 32px;
  margin-right: 32px;
  background: #100f0f !important;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 32px;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.05);
}
.modal-wrapper .slide-pane__content {
  padding: 24px;
}
@media (max-width: 768px) {
  .modal-wrapper .slide-pane__content {
    padding: 32px;
  }
}
@media (max-width: 768px) {
  .modal-wrapper {
    position: absolute;
    bottom: 0;
    width: 100% !important;
    height: -moz-fit-content !important;
    height: fit-content !important;
    margin-top: 0;
    margin-right: 0;
    border-radius: 32px 32px 0 0;
  }
}

.modal-burger {
  width: 100%;
  max-width: 360px;
  background: #100f0f !important;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
}
.modal-burger .slide-pane__content {
  padding: 0;
}
@media (max-width: 576px) {
  .modal-burger {
    max-width: 100%;
    width: 100% !important;
  }
}

.react-select-container .react-select__control {
  min-height: 55px;
  margin: -1px;
  background: transparent;
  border: 1px solid #414141;
  border-radius: 16px;
  transition: 0.8s;
}
.react-select-container .react-select__control:hover, .react-select-container .react-select__control:focus {
  border: 1px solid #b6b6b6;
  color: #ffffff;
}
.react-select-container .react-select__control--is-focused {
  border: 1px solid #b6b6b6;
  box-shadow: none;
}
.react-select-container .react-select__indicator-separator {
  display: none;
}
.react-select-container .react-select__placeholder {
  font-weight: 300;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.5);
}
.react-select-container .react-select__indicator path {
  color: #414141;
}
.react-select-container .react-select__menu {
  background: #100f0f;
  border-radius: 16px;
  box-shadow: none;
}
.react-select-container .react-select__option {
  font-weight: 300;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.5);
  border-radius: 16px;
}
.react-select-container .react-select__option--is-focused {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.15);
  border-radius: 16px;
}
.react-select-container .react-select__option--is-selected {
  cursor: pointer;
  color: #ffffff;
  background-color: unset;
  border-radius: 16px;
}

::-webkit-scrollbar {
  width: 4px !important;
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 2px !important;
  box-shadow: none !important;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1) !important;
  border-radius: 2px !important;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}

:root {
  --toastify-color-light: #100f0f !important;
  --toastify-text-color-light: #ffffff !important;
  --toastify-icon-color-success: #ff136d !important;
  --toastify-color-progress-success: linear-gradient(264.11deg, #ff136d -2.87%, #443de9 105.13%) !important;
  --toastify-icon-color-error: #ff136d !important;
  --toastify-color-progress-error: linear-gradient(264.11deg, #ff136d -2.87%, #443de9 105.13%) !important;
}

.Toastify__toast {
  border-radius: 16px !important;
}

.Toastify__close-button > svg {
  fill: #ffffff !important;
}

* {
  margin: 0;
  padding: 0;
  font-family: Oxanium, sans-serif !important;
}

body {
  overflow-y: overlay;
}

button {
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

:focus-visible {
  outline: none !important;
}

.ReactModal__Overlay {
  background-color: rgba(0, 0, 0, 0.5) !important;
  z-index: 10000;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/fonts/index.scss","webpack://./src/assets/styles/index.scss","webpack://./src/assets/styles/components/modal.scss","webpack://./src/assets/styles/variables/colors.scss","webpack://./src/assets/styles/mixin/breakpoints.scss","webpack://./src/assets/styles/components/select.scss","webpack://./src/assets/styles/components/scrollbar.scss","webpack://./src/assets/styles/components/toast.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,4CAAA;EACA,gBAAA;ACCF;ADEA;EACE,sBAAA;EACA,4CAAA;EACA,gBAAA;ACAF;ADGA;EACE,sBAAA;EACA,4CAAA;EACA,gBAAA;ACDF;ADIA;EACE,sBAAA;EACA,4CAAA;EACA,gBAAA;ACFF;ADKA;EACE,sBAAA;EACA,4CAAA;EACA,gBAAA;ACHF;ADMA;EACE,sBAAA;EACA,4CAAA;EACA,gBAAA;ACJF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,gBAAA;ACLF;AC/BA;EACE,eAAA;EACA,QAAA;EACA,8BCWS;EDVT,kCAAA;UAAA,0BAAA;EACA,UAAA;ADiCF;;AC9BA;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,mBCGS;EDFT,qCAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;ADiCF;;AC9BA;;EAEE,8BCTS;EDUT,kCAAA;UAAA,0BAAA;ADiCF;;AC9BA;EACE,UAAA;ADiCF;;AC9BA;EACE,UAAA;ADiCF;;AC9BA;EACE,uBAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,8BAAA;EACA,qCAAA;EACA,mBAAA;EACA,2CAAA;ADiCF;AC/BE;EACE,aAAA;ADiCJ;AGnDE;EFiBA;IAII,aAAA;EDkCJ;AACF;AGxDE;EFOF;IAmBI,kBAAA;IACA,SAAA;IACA,sBAAA;IACA,mCAAA;IAAA,8BAAA;IACA,aAAA;IACA,eAAA;IACA,4BAAA;EDkCF;AACF;;AC/BA;EACE,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,oCAAA;EACA,6BAAA;EACA,gCAAA;ADkCF;AChCE;EACE,UAAA;ADkCJ;AGzEE;EF8BF;IAaI,eAAA;IACA,sBAAA;EDkCF;AACF;;AIjHE;EACE,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AJoHJ;AInHI;EAEE,yBAAA;EACA,cFbE;AFiIR;AIhHE;EACE,yBAAA;EACA,gBAAA;AJkHJ;AI/GE;EACE,aAAA;AJiHJ;AI9GE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,+BF1BO;AF0IX;AI7GE;EACE,cFRS;AFuHb;AI5GE;EACE,mBFpBO;EEqBP,mBAAA;EACA,gBAAA;AJ8GJ;AI3GE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,+BF7CO;EE8CP,mBAAA;AJ6GJ;AI1GE;EACE,eAAA;EACA,qCF1CO;EE2CP,mBAAA;AJ4GJ;AIzGE;EACE,eAAA;EACA,cF/DI;EEgEJ,uBAAA;EACA,mBAAA;AJ2GJ;;AK1KA;EACE,qBAAA;AL6KF;;AK1KA;EACE,gDAAA;EACA,6BAAA;EACA,2BAAA;AL6KF;;AK1KA;EACE,+CAAA;EACA,6BAAA;AL6KF;;AK1KA;EACE,+CAAA;AL6KF;;AM/LA;EACE,0CAAA;EACA,+CAAA;EACA,iDAAA;EACA,yGAAA;EACA,+CAAA;EACA,uGAAA;ANkMF;;AM/LA;EACE,8BAAA;ANkMF;;AM/LA;EACE,wBAAA;ANkMF;;AA1MA;EACE,SAAA;EACA,UAAA;EACA,2CAAA;AA6MF;;AA1MA;EACE,mBAAA;AA6MF;;AA1MA;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AA6MF;;AA1MA;;EAEE,wBAAA;EACA,SAAA;AA6MF;;AA1MA;EACE,0BAAA;AA6MF;;AA1MA;EACE,wBAAA;AA6MF;;AA1MA;EACE,+CAAA;EACA,cAAA;AA6MF","sourcesContent":["@font-face {\n  font-family: 'Oxanium';\n  src: url('../../fonts/Oxanium-ExtraLight.ttf');\n  font-weight: 200;\n}\n\n@font-face {\n  font-family: 'Oxanium';\n  src: url('../../fonts/Oxanium-Light.ttf');\n  font-weight: 300;\n}\n\n@font-face {\n  font-family: 'Oxanium';\n  src: url('../../fonts/Oxanium-Regular.ttf');\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: 'Oxanium';\n  src: url('../../fonts/Oxanium-Medium.ttf');\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: 'Oxanium';\n  src: url('../../fonts/Oxanium-SemiBold.ttf');\n  font-weight: 600;\n}\n\n@font-face {\n  font-family: 'Oxanium';\n  src: url('../../fonts/Oxanium-Bold.ttf');\n  font-weight: 700;\n}\n\n@font-face {\n  font-family: 'Oxanium';\n  src: url('../../fonts/Oxanium-ExtraBold.ttf');\n  font-weight: 800;\n}\n","@import 'fonts';\n@import 'components/modal';\n@import 'components/select';\n@import 'components/scrollbar';\n@import 'components/toast';\n\n* {\n  margin: 0;\n  padding: 0;\n  font-family: Oxanium, sans-serif !important;\n}\n\nbody {\n  overflow-y: overlay;\n}\n\nbutton {\n  cursor: pointer;\n  background: none;\n  border: none;\n  outline: none;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type='number'] {\n  -moz-appearance: textfield;\n}\n\n:focus-visible {\n  outline: none !important;\n}\n\n.ReactModal__Overlay {\n  background-color: rgba(0, 0, 0, 0.5) !important;\n  z-index: 10000;\n}\n","@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.overlay-custom {\n  position: fixed;\n  inset: 0;\n  background: $black-30;\n  backdrop-filter: blur(5px);\n  z-index: 2;\n}\n\n.content-custom {\n  padding: 24px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: $black-bg;\n  border: 1px solid $black-15;\n  border-radius: 32px;\n  overflow: auto;\n  outline: none;\n}\n\n.overlay-side,\n.overlay-side-burger {\n  background: $black-30;\n  backdrop-filter: blur(5px);\n}\n\n.overlay-side {\n  z-index: 2;\n}\n\n.overlay-side-burger {\n  z-index: 1;\n}\n\n.modal-wrapper {\n  width: 480px !important;\n  height: calc(100% - 64px) !important;\n  margin-top: 32px;\n  margin-right: 32px;\n  background: $black-bg !important;\n  border: 1px solid $black-15;\n  border-radius: 32px;\n  box-shadow: 0 30px 60px $black-5;\n\n  .slide-pane__content {\n    padding: 24px;\n\n    @include md {\n      padding: 32px;\n    }\n  }\n\n  @include md {\n    position: absolute;\n    bottom: 0;\n    width: 100% !important;\n    height: fit-content !important;\n    margin-top: 0;\n    margin-right: 0;\n    border-radius: 32px 32px 0 0;\n  }\n}\n\n.modal-burger {\n  width: 100%;\n  max-width: 360px;\n  background: $black-bg !important;\n  border: 1px solid $black-30;\n  border-top-right-radius: 16px;\n  border-bottom-right-radius: 16px;\n\n  .slide-pane__content {\n    padding: 0;\n  }\n\n  @include sm {\n    max-width: 100%;\n    width: 100% !important;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n","@import './src/assets/styles/variables/colors';\n\n.react-select-container .react-select {\n  &__control {\n    min-height: 55px;\n    margin: -1px;\n    background: transparent;\n    border: 1px solid $grey-input;\n    border-radius: 16px;\n    transition: 0.8s;\n    &:hover,\n    &:focus {\n      border: 1px solid $grey-nav;\n      color: $white;\n    }\n  }\n\n  &__control--is-focused {\n    border: 1px solid $grey-nav;\n    box-shadow: none;\n  }\n\n  &__indicator-separator {\n    display: none;\n  }\n\n  &__placeholder {\n    font-weight: 300;\n    font-size: 18px;\n    line-height: 22px;\n    letter-spacing: -0.015em;\n    text-transform: capitalize;\n    color: $white-50;\n  }\n\n  &__indicator path {\n    color: $grey-input;\n  }\n\n  &__menu {\n    background: $black-bg;\n    border-radius: 16px;\n    box-shadow: none;\n  }\n\n  &__option {\n    font-weight: 300;\n    font-size: 18px;\n    line-height: 22px;\n    letter-spacing: -0.015em;\n    text-transform: capitalize;\n    color: $white-50;\n    border-radius: 16px;\n  }\n\n  &__option--is-focused {\n    cursor: pointer;\n    background-color: $black-15;\n    border-radius: 16px;\n  }\n\n  &__option--is-selected {\n    cursor: pointer;\n    color: $white;\n    background-color: unset;\n    border-radius: 16px;\n  }\n}\n","@import './src/assets/styles/variables/colors';\n\n::-webkit-scrollbar {\n  width: 4px !important;\n}\n\n::-webkit-scrollbar-track {\n  background: $white-5 !important;\n  border-radius: 2px !important;\n  box-shadow: none !important;\n}\n\n::-webkit-scrollbar-thumb {\n  background: $white-10 !important;\n  border-radius: 2px !important;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: $white-10 !important;\n}\n",":root {\n  --toastify-color-light: #100f0f !important;\n  --toastify-text-color-light: #ffffff !important;\n  --toastify-icon-color-success: #ff136d !important;\n  --toastify-color-progress-success: linear-gradient(264.11deg, #ff136d -2.87%, #443de9 105.13%) !important;\n  --toastify-icon-color-error: #ff136d !important;\n  --toastify-color-progress-error: linear-gradient(264.11deg, #ff136d -2.87%, #443de9 105.13%) !important;\n}\n\n.Toastify__toast {\n  border-radius: 16px !important;\n}\n\n.Toastify__close-button > svg {\n  fill: #ffffff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
